const _ = require('lodash')
const npmVersion = require('../package.json').version

const env = _.merge(process.env, typeof (window) === 'undefined' ? {} : window.__env__)

const environment = {
  development: {
    isProduction: false,
    gaTrackingCode: env.GA_TRACKING_CODE ||
      'UA-97183473-4',
    openBrowserAfterBuild: false,
    autoLogin: false,
    debug: true,
    tempUser: {
      accessToken:
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOjE0OTk4LCJoYXNoIjoiNGE0NjM2YTljMzg5OTdmOGU2YjQxOTljNjE5OWFjZDZhZGRkYWY4MzA5YzM1NGNiMTMyODhjYjU3YTZiZjU0ZSIsImlhdCI6MTQ2Mjg2NzQ4NSwiZXhwIjoxNDYyODg1NDg1fQ.MQRFIvC9Zol8NcpY0jcuUf3C-_k9B_4gu6p34K_rEhM',
      id: 6,
      email: 'dummy@dumm.com',
      firstName: 'Dummy',
      lastName: 'Dumm'
    },
    webAppAddress: (env.PUBLIC_PATH || '') + '/login',
    version: env.npm_package_version || '1',
    foUrl: env.FO_URL || '',
    displayVersion: env.DISPLAY_VERSION,
    fileSizeLimit: env.FILE_SIZE_LIMIT || 20971520
  },
  production: {
    isProduction: true,
    gaTrackingCode: env.GA_TRACKING_CODE ||
      'UA-97183473-2',
    foUrl: env.FO_URL,
    webAppAddress: env.FO_URL || '/',
    version: env.npm_package_version || '1',
    displayVersion: env.DISPLAY_VERSION,
    fileSizeLimit: env.FILE_SIZE_LIMIT || 20971520
  }
}[env.NODE_ENV || 'development']

export default {
  nodeEnv: env.NODE_ENV || 'development',
  sentry: env.SENTRY,
  productionServer: env.PRODUCTION_SERVER,
  webVersion: npmVersion,
  port: env.PORT || 3000,
  host: env.HOST || 'localhost',
  apiURL: env.API_URL,
  apiv2URL: env.API_V2_URL,
  apiURLfromServer:
    env.API_URL_FROM_SERVER ||
    env.API_URL,
  xFrameEnabled: env.X_FRAME_ENABLED,
  headerColor: env.HEADER_COLOR,
  sessionTtlMinutes: env.SESSION_TTL_MINUTES || 24 * 60,
  publicPath: env.PUBLIC_PATH || '',
  baseUrl: env.BASE_URL || '',
 foInternalUrl: env.FO_INTERNAL_URL || env.FO_URL || 'http://localhost:5001',
  sessionSecret: env.SESSION_SECRET,
  redisHost: env.REDIS_HOST,
  redisPort: env.REDIS_PORT,
  redisUrl: env.REDIS_URL,
  redisCluster: env.REDIS_CLUSTER,
  clientSecret: process.env.CLIENT_SECRET,
  clientId: process.env.CLIENT_ID,
  fileSizeLimit: env.FILE_SIZE_LIMIT || 20971520,
  isCSRFEnabled: env.IS_CSRF_ENABLED || false,
  cspSource: {
    default: env.CSP_SOURCE || '',
    script: env.CSP_SCRIPT_SOURCE || '',
    style: env.CSP_STYLE_SOURCE || '',
    connect: env.CSP_CONNECT_SOURCE || '',
    font: env.CSP_FONT_SOURCE || '',
    img: env.CSP_IMG_SOURCE || ''
  },
  exposeToClient: [
    'API_URL',
    'API_V2_URL',
    'API_URL_FROM_SERVER',
    'GA_TRACKING_CODE',
    'FO_URL',
    'DISPLAY_VERSION',
    'X_FRAME_ENABLED',
    'npm_package_version',
    'BASE_URL',
    'PUBLIC_PATH',
    'SENTRY',
    'PRODUCTION_SERVER',
    'npm_package_version',
    'HEADER_COLOR',
    'IS_CSRF_ENABLED',
    'CSP_SOURCE',
    'CSP_SCRIPT_SOURCE',
    'CSP_STYLE_SOURCE',
    'CSP_CONNECT_SOURCE',
    'CSP_FONT_SOURCE',
    'CSP_IMG_SOURCE'
  ],
  ...environment
}
